import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TicketService } from 'src/app/shared/services/ticket.service';
import { ITicket } from 'src/app/shared/models/ITicket.model';

@Injectable({
  providedIn: 'root',
})
export class BookingGuard implements CanDeactivate<unknown> {
  constructor(private ticketService: TicketService) {}
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const invoice = this.ticketService.bookTicket.getValue() as any;

    // if (invoice && invoice?.items?.length) {
    //   return confirm(`You have unsaved changes, leave anyway?`);
    // }

    return true;
  }
}
